import { render, staticRenderFns } from "./detail.vue?vue&type=template&id=b3e8ff38&scoped=true&"
import script from "./detail.vue?vue&type=script&lang=js&"
export * from "./detail.vue?vue&type=script&lang=js&"
import style0 from "./detail.vue?vue&type=style&index=0&id=b3e8ff38&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3e8ff38",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/manage.pc.frontend-purchase-test/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b3e8ff38')) {
      api.createRecord('b3e8ff38', component.options)
    } else {
      api.reload('b3e8ff38', component.options)
    }
    module.hot.accept("./detail.vue?vue&type=template&id=b3e8ff38&scoped=true&", function () {
      api.rerender('b3e8ff38', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/general/platform-sales-fee/detail.vue"
export default component.exports